import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props { readonly children: ReactNode }
interface State { readonly failed: boolean; readonly message: string }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false, message: '' }

  static getDerivedStateFromError(error: unknown): State {
    return { failed: true, message: error instanceof Error ? error.message : 'UNKNOWN INTERFACE FAILURE' }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('BLOCK//DEFENSE interface failure', error, info.componentStack)
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children
    return <main className="fatal-screen" role="alert"><section><div>B//D</div><small>RECOVERY CONSOLE · RC {__APP_VERSION__}</small><h1>INTERFACE LINK FAILED</h1><p>{this.state.message}</p><button type="button" onClick={() => window.location.reload()}>RELOAD DEFENSE GRID</button></section></main>
  }
}
